/* eslint-disable camelcase */
// import { fetchList } from '@/api/camera'
import { setMenu } from '@/utils/auth'
import {
  mdiAccountTie,
  mdiCalendar,
  mdiCalendarAccount,
  mdiCalendarClock,
  mdiCalendarEdit,
  mdiCalendarHeart,
  mdiCalendarMultiselect,
  mdiCashClock,
  mdiCheckDecagram,
  mdiClipboardEditOutline,
  mdiClipboardTextClock,
  mdiClockCheckOutline,
  mdiClockEditOutline,
  mdiClockPlusOutline,
  mdiCog,
  mdiFileDocumentOutline,
  mdiQrcodeScan,
  mdiStoreClock,
} from '@mdi/js'

const state = {
  list: [],
}

const mutations = {
  SET_MENUS: (state, list) => {
    state.list = list
  },
}

const actions = {
  updateMenus({ commit }, parameter) {
    console.log('store list parameter', parameter)

    return new Promise((resolve, reject) => {
      console.log('sysRoleMenus updateMenus', parameter)
      console.log('mdiAccountTie', mdiAccountTie)
      const icons = {
        mdiAccountTie,
        mdiQrcodeScan,
        mdiStoreClock,
        mdiCog,
        mdiCalendarEdit,
        mdiCalendarHeart,
        mdiFileDocumentOutline,
        mdiCalendarClock,
        mdiClockPlusOutline,
        mdiClockCheckOutline,
        mdiCalendarAccount,
        mdiCheckDecagram,
        mdiCalendar,
        mdiCalendarMultiselect,
        mdiCashClock,
        mdiClipboardTextClock,
        mdiClockEditOutline,
        mdiClipboardEditOutline,
      }
      if (parameter) {
        const menus = []
        parameter.forEach(endpointMenu => {
          const menuGroup = {
            sectionTitle: endpointMenu.sectionTitle,
            children: [],
          }
          if (endpointMenu.children) {
            endpointMenu.children.forEach(sysMenu => {
              // let sysMenu = roleMenu.sysMenu
              if (sysMenu.hidden) {
                return
              }
              const menu = {
                icon: sysMenu.icon && icons[sysMenu.icon] ? icons[sysMenu.icon] : '',
                title: sysMenu.name,
              }
              const children = []
              if (sysMenu.children) {
                // console.log('sysMenu.children', sysMenu.children)
                sysMenu.children.forEach(child => {
                  // console.log('child', child)
                  if (!child.hidden) {
                    children.push({
                      icon: child.icon && icons[child.icon] ? icons[child.icon] : '',
                      title: child.name,
                      to: child.url,
                    })
                  }
                })
              } else {
                menu.to = sysMenu.url
              }
              if (children.length > 0) {
                menu.children = children
              }
              menuGroup.children.push(menu)
            })
            menus.push(menuGroup)
          }
        })
        setMenu(menus)
        commit('SET_MENUS', menus)
        resolve(menus)
      }
    }).catch(error => {
      console.log('error', error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
